import { useEnquiryFormContext } from '@context/EnquiryFormContext'
import Button from '@global/Button'
import Image from '@global/Image'
import Raiting from '@global/Raiting'
import ShareButton from '@global/ShareButton'
import IconDownload from '@icons/Download'
import vCardCreator from '@lib/helpers/vcard'
import { Link } from '@routes'
import AgentMobileNavBarBottom from 'components/Agents/AgentProfile/AgentInfo/AgentMobileNavBarBottom'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import * as S from './StickyNavAgent.styled'

const EnquiryForm = dynamic(() => import('@global/Form/EnquiryForm'), {
  ssr: false,
})

const StickyNavAgent = ({
  name,
  jobTitle,
  email,
  image,
  shareObject,
  phone,
  showGetInTouch,
  showSendEnquiry,
  agentId,
  slug,
  reaRating,
  reaNumberOfReviews,
}) => {
  const [enquiryType, setEnquiryType] = useState('agent')
  const { setShowEnquiryForm } = useEnquiryFormContext()
  const [isFixedNav, setIsFixedNav] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        if (!isFixedNav) {
          setIsFixedNav(true)
        }
      } else {
        if (isFixedNav) {
          setIsFixedNav(false)
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isFixedNav])

  return (
    <>
      <S.StickyNavAgent active={isFixedNav}>
        <S.Agent>
          <Image src={image} alt={name} />
          <S.AgentInfo>
            <S.AgentInfoName>{name}</S.AgentInfoName>
            <Raiting rating={reaRating} numberOfReviews={reaNumberOfReviews} />
          </S.AgentInfo>
        </S.Agent>

        <S.StickyNavAgentActions>
          <div>
            {showGetInTouch && (
              <Link route={`/request-an-appraisal/${slug}/`} passHref>
                <Button border color='secondary'>
                  Free consultation
                </Button>
              </Link>
            )}
            {showSendEnquiry && email && (
              <Button
                border
                color='secondary'
                onClick={() => {
                  setEnquiryType('agent')
                  setShowEnquiryForm(true)
                }}
              >
                Send Enquiry
              </Button>
            )}
            {phone && (
              <a href={`tel:${phone}`} target='_blank'>
                <Button border color='secondary'>
                  {`Call ${phone}`}
                </Button>
              </a>
            )}
          </div>
          <S.ShareAction>
            <S.SaveContact
              onClick={() => {
                vCardCreator.makeVCard({
                  name: name,
                  tel: phone,
                  email,
                  photo: image,
                })
              }}
            >
              <IconDownload /> Save
            </S.SaveContact>
            <ShareButton
              heading='Share this Agent'
              shareInfo={shareObject}
              modalPosition='right'
            />
          </S.ShareAction>
        </S.StickyNavAgentActions>
      </S.StickyNavAgent>

      <AgentMobileNavBarBottom
        showSendEnquiry={showSendEnquiry}
        phone={phone}
        showGetInTouch={showGetInTouch}
        slug={slug}
      />

      <EnquiryForm
        type={enquiryType}
        agentName={name}
        agentSlug={slug}
        headerInfo={{ image, title: name, description: jobTitle, id: agentId }}
      />
    </>
  )
}

export default StickyNavAgent
